export const SESSION_IDLE_CONFIG = {
    idleWarningTimeInSeconds: 18 * 60,
    idleTimeoutTimeInSeconds: 20 * 60,
};
